export default __webpack_public_path__ + "static/media/6.76f69dd2.png";